module.exports = __webpack_public_path__ + "img/clockwise.3d5013c3.png";